// extracted by mini-css-extract-plugin
export default {"confirm":"styles_confirm__ko9C9","btn":"styles_btn__KEfw2","title":"styles_title__TB9ui"};